import React, {Component} from 'react';

export default class ExpandableContent extends Component {
    render() {
        return (
            <div className="expandable-content">
                <div className="header-section">
                    {this.props.title}
                </div>
                <div className="content-section">
                    {this.props.children}
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/js/components/expandable-content.js